import * as React from 'react';
import { Lazyloader } from '../Lazyloader/Lazyloader';
import type { NewsArticlePage } from '../Types';

export interface INewsLandingPageProps {
    items: NewsArticlePage[];
}

export class NewsLandingPage extends React.Component<INewsLandingPageProps> {
    constructor(props: INewsLandingPageProps) {
        super(props);
    }

    public renderItem(item: NewsArticlePage, index: number): JSX.Element {
        return (
            <div className="news-module__news-box col-12 col-sm-6 col-lg-4 news-module--grey-box" key={index}>
                <a href={item.url} className="fold fold--orange">
                    <Lazyloader image={item.image} hasVideo={item.hasVideo} isBackgroundImage={false} />
                    <div className="news-module__text news-module--text">
                        <strong>{item.title}</strong>
                        <div className="news-module__text-summary">
                            {item.newsCategory ? <span className="news-module__news-category">{item.newsCategory} · </span> : null}
                            {item.summary}
                        </div>
                    </div>
                </a>
            </div>
        );
    }

    public render(): JSX.Element {
        return <div className="row article__layout">{this.props.items.map(this.renderItem)}</div>;
    }
}
